import { render, staticRenderFns } from "./uploadImgPage.vue?vue&type=template&id=410d400c&scoped=true&"
import script from "./uploadImgPage.vue?vue&type=script&lang=js&"
export * from "./uploadImgPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgPage.vue?vue&type=style&index=0&id=410d400c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d400c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410d400c')) {
      api.createRecord('410d400c', component.options)
    } else {
      api.reload('410d400c', component.options)
    }
    module.hot.accept("./uploadImgPage.vue?vue&type=template&id=410d400c&scoped=true&", function () {
      api.rerender('410d400c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/afterSale/uploadImgPage.vue"
export default component.exports